var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "table-approvals", attrs: { "no-body": "" } },
    [
      _c("b-table", {
        staticClass: "mb-0",
        attrs: {
          items: _vm.approvals,
          responsive: "",
          fields: _vm.fields,
          selectable: "",
          "select-mode": "single"
        },
        on: { "row-selected": _vm.onApprovalSelected },
        scopedSlots: _vm._u([
          {
            key: "cell(numero)",
            fn: function(data) {
              return [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  data.item.numero
                    ? _c("span", [_vm._v(" " + _vm._s(data.item.numero) + " ")])
                    : _c("span", [_vm._v(" -- ")])
                ])
              ]
            }
          },
          {
            key: "cell(nombreAprobacion)",
            fn: function(data) {
              return [
                _c("div", {}, [
                  _c("div", { staticClass: "font-weight-bolder" }, [
                    _vm._v(" " + _vm._s(data.item.nomnbreEjecucion) + " ")
                  ]),
                  _c("div", { staticClass: "font-small-2 text-muted" }, [
                    _vm._v(" " + _vm._s(data.item.nombreAprobacion) + " ")
                  ])
                ])
              ]
            }
          },
          {
            key: "cell(unidadNombre)",
            fn: function(data) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    data.item.unidadNombre
                      ? _c("b-badge", { attrs: { variant: "light-info" } }, [
                          _vm._v(" " + _vm._s(data.item.unidadNombre) + " ")
                        ])
                      : _c(
                          "b-badge",
                          { attrs: { variant: "light-secondary" } },
                          [_vm._v(" -- ")]
                        )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "cell()",
            fn: function(data) {
              return [
                _c("b-progress", {
                  attrs: {
                    value: data.item.numeroPaso,
                    max: data.item.totalPasos,
                    variant: "primary",
                    striped: ""
                  }
                }),
                _c(
                  "div",
                  { staticClass: "font-small-2 text-muted text-center" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(data.item.numeroPaso) +
                        " / " +
                        _vm._s(data.item.totalPasos) +
                        " "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "cell(fechaInicioPaso)",
            fn: function(data) {
              return [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("span", { staticClass: "font-weight-bolder mr-1" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(data.item.fechaInicioPaso)
                        ) +
                        " "
                    )
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }